import { type ReactNode } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { contributionImportPath } from "@/lib/canonical-entry-points";
import { canImportContributions } from "@/lib/contribution-import-access";

export function ContributionImportRedirect({ children }: { children?: ReactNode }) {
  const [searchParams] = useSearchParams();
  const { appRoles, isLoading } = usePermissions();

  if (!isLoading && searchParams.has("import") && canImportContributions(appRoles)) {
    return <Navigate to={contributionImportPath} replace />;
  }

  return <>{children}</>;
}
